<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container_a">
          <i @click="close()" class="el-icon-error"></i>

          <div class="modal-container">
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: "modal",
  methods: {
    close() {
      this.$root.$emit("closeModal");
    }
  }
};
</script>
<style lang="scss">
.modal {
  &-mask {
    position: fixed;
    z-index: 10;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
  }
  &-wrapper {
    display: table-cell;
    vertical-align: middle;
    position: relative;

    .el-icon-error {
      position: absolute;
      top: 1%;
      right: 7%;
      font-size: 30px;
      cursor: pointer;
      color: #026a45;
      z-index: 1;
      &:hover {
        color: #026a456e;
      }
    }
  }
  &-container {
    width: auto;
    max-width: 90%;
    margin: 0px auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    font-family: Helvetica, Arial, sans-serif;
    height: 90%;
    overflow-y: scroll;
  }
  &-container_a {
    width: auto;

    max-width: 90%;
    margin: 0px auto;
    position: relative;
    height: 90%;
  }
  &-header h3 {
    margin-top: 0;
    color: #42b983;
  }
  &-body {
    margin: 20px 0;
  }
  &-default-button {
    float: right;
  }
  &--enter {
    opacity: 0;
  }
  &-leave-active {
    opacity: 0;
  }
  &-enter &-container,
  &-leave-active &-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Modals/modal.vue